import script from "./DownloadAppBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadAppBanner.vue?vue&type=script&setup=true&lang=js"

import "./DownloadAppBanner.vue?vue&type=style&index=0&id=53a662bf&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53a662bf"]])

export default __exports__